import HouseImg from './house.svg';
import HouseSuccessImg from './house-success.svg';
import AffectedImg from './affected.svg';
import AffectedSuccessImg from './affected-success.svg';
import VentImg from './vent.svg';
import VentSuccessImg from './vent-success.svg';
import PlusIcon from './plus-icon.svg';

import PhotoFrontImg from './photos-front-house.png';
import PhotoFrontImg2 from './photos-front-house2.png';
import PhotoBack from './photos-back-house.png';
import PhotoBack2 from './photos-back-house2.png';
import PhotoWideAngle from './photos-wide-angle.png';
import PhotoWideAngle2 from './photos-wide-angle2.png';
import PhotoWideAngle3 from './photos-wide-angle3.png';
import PhotoWideAngle4 from './photos-wide-angle4.png';

import PhotoCloseUp from './photos-close-up.png';
import PhotoCloseUp2 from './photos-close-up2.png';
import PhotoCloseUp3 from './photos-close-up3.png';
import PhotoCloseUp4 from './photos-close-up4.png';
import PhotoFastener from './photos-fasteners.png';
import PhotoFastener2 from './photos-fasteners2.png';
import PhotoFastener3 from './photos-fasteners3.png';
import PhotoFastener4 from './photos-fasteners4.png';

import PhotoVent from './photos-vent.png';
import PhotoVent2 from './photos-vent2.png';
import PhotoVent3 from './photos-vent3.png';
import PhotoVent4 from './photos-vent4.png';

import PhotoShingle from './shingle-sample.png';
import PhotoShingle2 from './shingle-sample2.png';

import ProofOfOwnerShipImg from './proof-doc-icon.svg';
import ProofOfOwnerShipSuccess from './proof-doc-success.svg';
import ProofOfRoofImg from './proof-of-roof.svg';
import ProofOfRoofSuccessImg from './proof-of-roof.success.svg';

import BoxImg from './box.svg';
import TruckImg from './truck.svg';
import NailingZoneImg from './nailing-zone.svg';
import WarningImg from './warning.svg';

import ReleaseTapeImg from './release-tape.png'

import ClaimOverviewThumbnail from './warranty_claim_overview_thumbnail.png';
import PhotoRequirementsThumbnail from './warranty_photo_requirements_thumbnail.png';
import PopThumbnail from './warranty_proof_of_purchase_thumbnail.png';

export {
  ClaimOverviewThumbnail,
  PhotoRequirementsThumbnail,
  PopThumbnail,
  ReleaseTapeImg,
  WarningImg,
  BoxImg,
  TruckImg,
  NailingZoneImg,
  ProofOfOwnerShipImg,
  ProofOfOwnerShipSuccess,
  ProofOfRoofImg,
  ProofOfRoofSuccessImg,
  HouseImg,
  HouseSuccessImg,
  AffectedImg,
  AffectedSuccessImg,
  VentImg,
  VentSuccessImg,
  PlusIcon,
  PhotoFrontImg,
  PhotoFrontImg2,
  PhotoBack,
  PhotoBack2,
  PhotoWideAngle,
  PhotoWideAngle2,
  PhotoWideAngle3,
  PhotoWideAngle4,
  PhotoCloseUp,
  PhotoCloseUp2,
  PhotoCloseUp3,
  PhotoCloseUp4,
  PhotoFastener,
  PhotoFastener2,
  PhotoFastener3,
  PhotoFastener4,
  PhotoVent,
  PhotoVent2,
  PhotoVent3,
  PhotoVent4,
  PhotoShingle,
  PhotoShingle2
};
